// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__21fcD","footer":"ModalCreateQualiphyProcedure_footer___6rI5","additionData":"ModalCreateQualiphyProcedure_additionData__3SCHx"};